import { ArrowUpRight } from "lucide-react";
import { Reveal, Chapter } from "@/components/portfolio/motion";

const PROJECTS = [
  {
    n: "01",
    title: "Malinky Music",
    desc: "Built an end-to-end system for a music business: a full public facing website plus a custom backend operations tool, taken from concept to production using Lovable and Emergent.",
    url: "https://malinkymusic.com/",
  },
  {
    n: "02",
    title: "Elevante AI",
    desc: "Vibe-coded a client management app using Emergent, delivering production-ready ops tooling without a dedicated engineering team.",
    url: "https://elevante.ai/",
  },
  {
    n: "03",
    title: "Aspen Hair Salon",
    desc: "Built a booking and client management app for a busy salon, giving them scheduling and client ops without needing to hire an engineer.",
    url: "https://www.aspensalonandspa.in/",
  },
];

const Card = ({ p, i }) => (
  <Reveal delay={i * 0.08}>
    <a
      data-testid={`project-card-${i}`}
      href={p.url}
      target="_blank"
      rel="noopener noreferrer"
      className="group relative flex flex-col h-full rounded-3xl border border-line bg-surface p-7 sm:p-8 transition-all duration-300 hover:border-accent/50 hover:shadow-[0_30px_60px_-32px_rgba(23,22,15,0.35)] hover:-translate-y-1"
    >
      <div className="flex items-start justify-between">
        <span className="font-mono text-xs tracking-[0.2em] text-muted">
          {p.n}
        </span>
        <span className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-line text-ink-soft group-hover:bg-accent group-hover:text-white group-hover:border-accent transition-all duration-300">
          <ArrowUpRight className="w-4 h-4 group-hover:rotate-45 transition-transform duration-300" />
        </span>
      </div>
      <h3 className="mt-8 font-display text-2xl font-bold text-ink group-hover:text-accent transition-colors">
        {p.title}
      </h3>
      <p className="mt-3 text-ink-soft leading-relaxed flex-1">{p.desc}</p>
      <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-accent">
        Visit site
        <ArrowUpRight className="w-4 h-4" />
      </span>
    </a>
  </Reveal>
);

export const Projects = () => (
  <section
    id="projects"
    data-testid="projects-section"
    className="scroll-mt-20 max-w-6xl mx-auto px-5 sm:px-8 py-20 sm:py-28 border-t border-line"
  >
    <Chapter num="04 / Projects" label="Projects" testId="projects-chapter" />
    <Reveal>
      <p className="max-w-2xl -mt-6 mb-12 text-lg text-ink-soft leading-relaxed">
        Software I designed and shipped using AI tools like Lovable and Emergent,
        for real clients with real users.
      </p>
    </Reveal>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {PROJECTS.map((p, i) => (
        <Card key={i} p={p} i={i} />
      ))}
    </div>
  </section>
);
